module.exports = __webpack_public_path__ + "media/images/input_state_icon/wand-fe4e06f672b9f03caddd331085ae9f61.svg";